import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../../../common/axios"
import Column from "../../../../../common/components/Column"
import LengthLimitedTextField from "../../../../../common/components/LengthLimitedTextField"
import DialogHeader from "../../../components/DialogHeader"
import { useDialogContainer } from "../../../utils"

export default function CreateNoteDialog({ candidate, open, onClose }) {
  const [title, setTitle] = useState("")
  const [content, setContent] = useState("")
  const [isCreating, setIsCreating] = useState(false)
  const axios = useAuthorizedAxiosClient()

  const Container = useDialogContainer()

  function resetForm() {
    setTitle("")
    setContent("")
  }

  function handleSoftClose() {
    onClose()
  }

  function handleAddButtonClicked() {
    setIsCreating(true)
    axios
      .post(`/crm/api/notes/${candidate.id}/`, { title, content })
      .then(({ data }) => {
        resetForm()
        onClose(data)
      })
      .finally(() => setIsCreating(false))
  }

  return (
    <Container open={open} onClose={handleSoftClose} anchor="right">
      <DialogHeader title="Add Note" onClose={handleSoftClose} />
      <DialogContent>
        <Column gap={3}>
          <LengthLimitedTextField
            label="Title"
            value={title}
            setValue={setTitle}
            required
            maxLength={64}
          />
          <TextField
            label="Content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            multiline
            rows={3}
            maxRows={3}
            fullWidth
          />
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isCreating}
          disabled={!title || !content}
          onClick={handleAddButtonClicked}
        >
          Add
        </LoadingButton>
      </DialogActions>
    </Container>
  )
}
